<template>
  <ElConfigProvider>
    <RouterView v-slot="{Component}">
      <KeepAlive :exclude="['Login']">
        <component :is="Component"/>
      </KeepAlive>
    </RouterView>
  </ElConfigProvider>
</template>

<script setup>
import useSettingsStore from '@/store/modules/settings'
import {handleThemeStyle} from '@/utils/theme'
import {ElConfigProvider} from 'element-plus'

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme)
  })
})
</script>
